import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { WebSocketService } from '../services/web-socket/web-socket.service';

@Injectable()
export class WebSocketInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(environment.apiUrl) && !req.url.includes(environment.graphqlUrl)) {
      return next.handle(req);
    }
    const headers: HttpHeaders = req.headers.set('X-Semeris-Tab-Id', WebSocketService.Id);
    return next.handle(req.clone({ headers }));
  }
}
